import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { StoreContext } from "redux-react-hook";
import store from "./store/store";
import { ActivityIndicator } from "antd-mobile";
// import "antd-mobile/dist/antd-mobile.css";
import * as serviceWorker from "./serviceWorker";
import {getUserInfoFromApp} from './app/getUserInfoFromApp'
import "./index.css";
getUserInfoFromApp().then(()=>{
  ReactDOM.render(
    <StoreContext.Provider value={store}>
      <BrowserRouter>
        <Suspense fallback={<ActivityIndicator toast text="加载中..." />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </StoreContext.Provider>,
    document.getElementById("root")
  );
  
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
